import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Icon from 'components/common/Icon/Icon'
import Link from 'components/common/Link/Link'

const BOTGlobalSearchSummary = ({ results }) =>
  <aside data-global-search-summary>
    <Caption data-at-globalsearch-caption>Results Type</Caption>
    <React.Fragment>
      {
        results.map(({ name, totalNumRecs, viewAllLink }, index) =>
          <SummaryLink data-at-globalsearch-resulttype to={ viewAllLink } key={ index }>
            { name } ({ totalNumRecs })
            <LinkIcon asset={ 'arrow-down-gray' } />
          </SummaryLink>
        )
      }
    </React.Fragment>
  </aside>

BOTGlobalSearchSummary.propTypes = {
  results: PropTypes.arrayOf(PropTypes.shape())
}

export default BOTGlobalSearchSummary

BOTGlobalSearchSummary.type = ''


const SummaryLink = styled(Link)`
  position: relative;
  display: block;
  padding: 20px 20px 20px 0;
  border-top: 1px solid ${Theme.colors.light_grey};
  border-bottom: 1px solid ${Theme.colors.light_grey};
  color: ${Theme.colors.black};
  font-weight: 600;
  text-decoration: none;
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }

  & + & {
    margin-top: -1px;
  }

  &:last-of-type {
    border-width: 1px 0;
  }
`

const LinkIcon = styled(Icon)`
  width: 18px;
  position: absolute;
  top: 50%;
  right: 0;
  margin-top: -9px;
  transform: rotateZ(-90deg);
`

const Caption = styled.h2`
  margin: 0 0 1em;
  ${Mixin.font.GothamBold(26, 600)}
`
